import React, { useState, useEffect, useRef } from 'react';
import { analyticsChoice, chooseAnalytics, resolveAnalyticsPolicy } from '../utils/analyticsConsent';
import { adsChoice, chooseAds, redditLanding, startRedditAds, trackRedditPageView } from '../utils/redditAds';
import './AnalyticsConsent.css';
export default function AnalyticsConsent() {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(false);
  const [analytics, setAnalytics] = useState(analyticsChoice() !== 'rejected');
  const [advertising, setAdvertising] = useState(adsChoice() === 'accepted');
  const bannerRef = useRef(null);
  const returnFocus = useRef(null);
  useEffect(() => {
    let active = true;
    resolveAnalyticsPolicy().then(({ prompt }) => {
      if (!active) return;
      startRedditAds();
      trackRedditPageView();
      if (!returnFocus.current) setOpen(prompt || (redditLanding() && !adsChoice() && navigator.globalPrivacyControl !== true && navigator.doNotTrack !== '1'));
    });
    return () => { active = false; };
  }, []);
  useEffect(() => {
    const reopen = () => { returnFocus.current = document.activeElement; setAnalytics(analyticsChoice() !== 'rejected'); setAdvertising(adsChoice() === 'accepted'); setSettings(true); setOpen(true); };
    window.addEventListener('sonikly-open-cookie-settings', reopen);
    return () => window.removeEventListener('sonikly-open-cookie-settings', reopen);
  }, []);
  useEffect(() => {
    if (open && returnFocus.current) bannerRef.current?.querySelector('button')?.focus();
  }, [open]);
  if (!process.env.REACT_APP_GA4_MEASUREMENT_ID || window.location.pathname === '/reset-password') return null;
  const choose = (ga, ads) => { chooseAnalytics(ga ? 'accepted' : 'rejected'); chooseAds(ads ? 'accepted' : 'rejected'); setOpen(false); setSettings(false); returnFocus.current?.focus(); returnFocus.current = null; };
  return open ? <section ref={bannerRef} className="analytics-consent" aria-label="Cookie preferences">
    <div><p>We use optional Google Analytics cookies to improve the website and Reddit Ads measurement to understand which ads lead to sign-ups and trials. <a href="/privacy">Privacy policy</a></p>
      {settings && <div className="analytics-consent-options">
        <label><input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />Website analytics</label>
        <label><input type="checkbox" checked={advertising} onChange={(e) => setAdvertising(e.target.checked)} />Reddit ad measurement</label>
      </div>}
    </div>
    <div className="analytics-consent-actions"><button className="analytics-consent-accept" onClick={() => settings ? choose(analytics, advertising) : choose(true, true)}>{settings ? 'Save preferences' : 'Accept all'}</button><button onClick={() => choose(false, false)}>Reject optional</button>{!settings && <button onClick={() => setSettings(true)}>Customize</button>}</div>
  </section> : null;
}
